<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_bilgileri"  :show_button="false" ></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">
<ClickEditInputText  :title="$store.state.languages.lang_phrases.tedarikci_ismi" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>

<ClickEditInputText  :title="$store.state.languages.lang_phrases.tedarikci_kodu" :value="item.suppliercode" valkey="suppliercode" @dataChanged="dataChanged"></ClickEditInputText>



<ClickEditSelect   :title="$store.state.languages.lang_phrases.ulke" :value="item.location.country_id" valkey="country_id" @dataChanged="dataChanged"  :options="countries" :filter="true"  :color_selector="false" />

<ClickEditSelect   :title="$store.state.languages.lang_phrases.sehir" :value="item.location.city_id" valkey="city_id" @dataChanged="dataChanged"  :options="cities" :filter="true"  :color_selector="false" />


<ClickEditInputText  :title="$store.state.languages.lang_phrases.adres" :value="item.location.address" valkey="address" @dataChanged="dataChanged"></ClickEditInputText>


<!--
<ClickEditMap  
:title="$store.state.languages.lang_phrases.adres" 
:value="item.location.address" 
:lat="item.location.latitude" 
:lng="item.location.longitude" 
valkey="address" 
@geolocationChanged="geolocationChanged"

></ClickEditMap>
-->

<ClickEditInputText  :title="$store.state.languages.lang_phrases.posta_kodu" :value="item.location.zipcode" valkey="zipcode" @dataChanged="dataChanged"></ClickEditInputText>








<ClickEditInputText  :title="$store.state.languages.lang_phrases.enlem" :value="item.location.latitude" valkey="latitude" @dataChanged="dataChanged"></ClickEditInputText>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.boylam" :value="item.location.longitude" valkey="longitude" @dataChanged="dataChanged"></ClickEditInputText>
















<br/><br/><br/><br/><br/>
</div>
</template>
</div>



</template>


<script>
import CustomAttributeEditor from "./CustomAttributeEditor"
export default {

  name: 'SupplierGeneral',

  data () {
    return {
    	item:null,
    	loading:true,    		
     	countries:[],  	
     	cities:[],
    }
  },
  components:{CustomAttributeEditor},
  mounted()
  {
  	this.$store.dispatch('ui/setActiveTab',"genel") 
  	this.getData()
  },
  computed:{
  	location()
  	{
  		if(this.item)
  		{
  			if(this.item.location)
  			{
  				return this.item.location
  			}
  			return false
  		}
  		return false
  	}  	
  },
  methods:{
  	async getData()
    {
    		this.countries = await this.generalApiGetWithoutLoader("countries")
    		
        this.item = await this.generalApiGetWithoutLoader("supplier/"+this.$route.params.id)
        
        
        

        
        
        if(this.item.location.country_id)
        {
        	this.getCities(this.item.location.country_id)
        }
        this.$store.dispatch('suppliers/setSupplier',this.item) 
        this.loading = await false
    },
    async getCities(country_id)
    {
    	this.cities = await this.generalApiGetWithoutLoader("cities/"+country_id)
    	
    },
    geolocationChanged(data)
    {
    	let formdata = new FormData()
    	formdata.append("address",data.value)
    	formdata.append("latitude",data.geolocation.lat)
    	formdata.append("longitude",data.geolocation.lng)
    	this.generalSubmission(formdata,"supplier_geolocation/"+this.item.id,this.afterdataChanged)
    },
    dataChanged(data)
    {
    	if(data.key=="country_id")
    	{
    		this.getCities(data.value)
    	}
    	console.log(data)
    	let formdata = new FormData()
    	formdata.append(data.key,data.value)
    	this.generalSubmission(formdata,"supplier/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
    	console.log(response.data)
    	this.getData()    	    	
    },
    attributeChanged(data)
    {
    	console.log(data)
    	console.log(this.$route.params)
    	//return false
    	let formdata = new FormData()
    	formdata.append("data",data.value)
    	formdata.append("customattribute_id",data.key)
    	formdata.append("supplier_id",this.$route.params.id)
    	this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+this.item.id,this.afterdataChanged)
    },    
    dataReneved()
    {
      this.getData()
    },
  }
};
</script>

<style lang="css" scoped>
</style>